export const DEFAULT_VIEWBOX = '0 0 110 110';
